import { render, staticRenderFns } from "./relvendas.vue?vue&type=template&id=56f156da&"
import script from "./relvendas.vue?vue&type=script&lang=js&"
export * from "./relvendas.vue?vue&type=script&lang=js&"
import style0 from "./relvendas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports